/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Output_LabelInputs */

const en_csv_output_label = /** @type {(inputs: Csv_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV Output`)
};

const ko_csv_output_label = /** @type {(inputs: Csv_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 출력`)
};

const ja_csv_output_label = /** @type {(inputs: Csv_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV出力`)
};

/**
* | output |
* | --- |
* | "CSV Output" |
*
* @param {Csv_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_output_label = /** @type {((inputs?: Csv_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_output_label(inputs)
	if (locale === "ko") return ko_csv_output_label(inputs)
	return ja_csv_output_label(inputs)
});